import React from "react";
import WhatsAppIcon from "./WhatsAppIcon";
import { companyInfo } from "../data/mock";

const WhatsAppButton = () => {
  return (
    <a
      href={companyInfo.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 right-5 md:right-6 z-[70] group"
    >
      {/* pulse ring */}
      <span
        className="absolute inset-0 rounded-full animate-ping opacity-40"
        style={{ background: "#25d366" }}
      />
      <span
        className="relative flex items-center justify-center w-14 h-14 rounded-full shadow-xl shadow-emerald-500/40 text-white group-hover:scale-110 transition-transform"
        style={{ background: "linear-gradient(135deg, #25d366 0%, #128c7e 100%)" }}
      >
        <WhatsAppIcon size={28} />
      </span>
    </a>
  );
};

export default WhatsAppButton;
